import { inject } from '@angular/core';
import type { CanDeactivateFn } from '@angular/router';
import { DfDialogService } from '@digital-factory/df-design-system-v22';
import { firstValueFrom } from 'rxjs';
import { TranslateService } from '../../shared/services/i18n.service';
import type { CreateNotice } from './create-notice';

export const unsavedNoticeGuard: CanDeactivateFn<CreateNotice> = async (component) => {
  if (!component.hasProgress()) return true;

  const translate = inject(TranslateService);
  const t = (key: string) => translate.getKeyTranslation(key)();

  const dialogRef = inject(DfDialogService).openConfirmationDialog(
    {
      title: t('createNotice.leaveDialog.title'),
      text: t('createNotice.leaveDialog.text'),
      confirmLabel: t('createNotice.leaveDialog.confirm'),
      cancelLabel: t('createNotice.leaveDialog.cancel'),
      variant: 'warning',
    },
    { disableClose: true },
  );

  dialogRef.componentInstance?.confirmed.subscribe(() => dialogRef.close(true));

  return (await firstValueFrom(dialogRef.closed)) === true;
};
